import React from 'react';
import { Title } from '../../Typography/index.js';
import { Modal, useModalContext } from '../Modal.js';
/**
 * Wizards are multi-step workflows, generally involving forms.
 *
 * The wizard components here, in `@panwds/react-ui`, only provide the visual
 * elements of the wizard - navigation, layout, actions.
 *
 * See the sister wizard components in the `@panwds/react-form` for common
 * form use cases.
 *
 * ### Import Guide
 *
 * ```jsx
 * import { ModalWizardBody, ModalWizardNavItem, ModalWizardSummary, ModalWizardStepSummary } from '@panwds/react-ui';
 * ```
 */
export function ModalWizardBody({ activeStepTitle, children, navItems }) {
    const { size } = useModalContext();
    return (React.createElement("div", { className: "twds-flex twds-flex-1 twds-w-full", style: { maxHeight: Modal.bodyMeasurements[size].maxHeight } },
        React.createElement("nav", { className: "twds-flex twds-flex-col twds-h-full twds-w-52 twds-bg-gray-100 twds-overflow-y-auto twds-scrollbar-default dark:twds-scrollbar-track-dark dark:twds-scrollbar-thumb-dark dark:twds-scrollbar-corner-dark" },
            React.createElement("ol", { className: "twds-box-border twds-relative twds-list-none twds-p-0 twds-m-0 twds-z-10" }, navItems)),
        React.createElement("div", { className: "twds-p-4 twds-w-full twds-overflow-auto twds-scrollbar-default dark:twds-scrollbar-track-dark dark:twds-scrollbar-thumb-dark dark:twds-scrollbar-corner-dark" },
            React.createElement(Title, { addClassName: "twds-pb-4", level: 4, size: "xs" }, activeStepTitle),
            children)));
}
//# sourceMappingURL=ModalWizardBody.js.map